import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { wildCardSearch } from 'actions/wildCard';
import TaxonomyBrandPage from 'containers/TaxonomyBrandPage';
import Landing from 'containers/Landing';
import { Loader } from 'components/Loader';
import { seoTermToHumanTerm } from 'helpers/SeoUtils';

export class WildCard extends Component {
  static fetchDataOnServer(store, location, params) {
    const term = seoTermToHumanTerm(params.seoName);
    return store.dispatch(wildCardSearch({ term }));
  }

  componentDidMount() {
    const { params: { seoName }, term: currentTerm, wildCardSearch } = this.props;
    const term = seoTermToHumanTerm(seoName);
    // need to populate term in state, trick wildcard container into not refetching
    if (term !== currentTerm) {
      wildCardSearch({ term });
    }
  }

  componentDidUpdate(prevProps) {
    const { term: prevTerm, wildCardSearch } = prevProps;
    const { params: { seoName } } = this.props;
    const term = seoTermToHumanTerm(seoName);
    if (term !== prevTerm) {
      wildCardSearch({ term });
    }
  }

  render() {
    const { location, routeDetails = {}, setLayoutOption, route } = this.props;
    const commonProps = { location, setLayoutOption };
    const { type, term, brand_id: brandId, page_name: pageName } = routeDetails;

    const paramPageName = { pageName };
    const paramBrandId = { brandId };
    const paramSeoName = { seoName: encodeURIComponent(term) };

    switch (type) {
      case 'landing':
        return <Landing { ...commonProps } params={paramPageName} />;
      case 'brand':
        return <TaxonomyBrandPage { ...commonProps } params={paramBrandId} />;
      case 'search':
        const { SearchComponent } = route;
        return <SearchComponent { ...commonProps } params={paramSeoName} route={route} />;
      default:
        return <Loader />;
    }
  }
}

WildCard.contextTypes = {
  testId: PropTypes.func
};

function mapStateToProps(state) {
  const { wildCard: { term, routeDetails } } = state;
  return {
    routeDetails,
    term
  };
}

export default connect(mapStateToProps, { wildCardSearch })(WildCard);
